import EditProfile from "../../Merchant/EditProfileForm/EditProfile";

export default EditProfile;


